import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image
} from "@react-pdf/renderer";
import ttdKepsek from "../../../assets/tt.jpeg";
/* ================= STYLE ================= */
const styles = StyleSheet.create({
  page: {
    size: "A4",
    padding: "5mm",
    flexDirection: "row",
    flexWrap: "wrap"
  },

  /* ===== KARTU ===== */
  card: {
    width: "95mm",
    height: "54mm",
    margin: "1mm",
    padding: "3mm",
    borderWidth: 1,
    borderColor: "#000",
    fontSize: 8,
    position: "relative"
  },

  /* ===== HEADER ===== */
  header: {
    textAlign: "center",
    marginBottom: 3
  },

  titleSmall: {
    fontSize: 7
  },

  titleMain: {
    fontSize: 9,
    fontWeight: "bold"
  },

  underline: {
    borderBottomWidth: 1,
    borderBottomColor: "#000",
    paddingBottom: 1,
    marginBottom: 3
  },

  /* ===== CONTENT ===== */
  row: {
    flexDirection: "row",
    marginBottom: 1
  },

  label: {
    width: 55
  },

  text: {
    fontSize: 8
  },

  /* ===== FOOTER / TTD ===== */
  footer: {
    position: "absolute",
    right: 6,
    bottom: 5,
    textAlign: "right",
    fontSize: 6,
    lineHeight: 1.2
  },

  kepala: {
  
    fontWeight: "bold",
     textAlign: "left",
  },
  ttd: {
  height: 20,
}
});

/* ================= DOCUMENT ================= */
const KartuUjianPDF = ({ data = [] }) => (
  <Document>
    <Page style={styles.page} wrap>
      {data.map((item, i) => (
        <View key={i} style={styles.card} wrap={false}>

          {/* ===== HEADER ===== */}
          <View style={styles.header}>
            <Text style={styles.titleSmall}>
              PENILAIAN AKHIR SEMESTER
            </Text>
            <Text style={styles.titleSmall}>
              SMKN PERTANIAN TERPADU PEKANBARU
            </Text>

            <View style={styles.underline}>
              <Text style={styles.titleMain}>
                KARTU PESERTA
              </Text>
            </View>
          </View>

          {/* ===== BIODATA ===== */}
          <View style={styles.row}>
            <Text style={styles.label}>Nama</Text>
            <Text style={styles.text}>: {item.nama}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Username</Text>
            <Text style={styles.text}>: {item.uid}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Password</Text>
            <Text style={styles.text}>: {item.password}</Text>
          </View>

          <View style={styles.row}>
            <Text style={styles.label}>Kelas/Ruang</Text>
            <Text style={styles.text}>: {item.nama_rm}</Text>
          </View>

          {/* ===== FOOTER / TTD ===== */}
          <View style={styles.footer}>
            <Text>Pekanbaru, 28 Fenruari 2026</Text>
            <Text>Kepala Sekolah</Text>
<Image src={ttdKepsek} style={styles.ttd} />
            <Text style={styles.kepala}>
              ELVITA HERASANTY, S.IP, M.Pd{"\n"}
                NIP.197605312005022001
            </Text>
             
          </View>

        </View>
      ))}
    </Page>
  </Document>
);

export default KartuUjianPDF;